export const fishSpeciesList = [
  "Blue Marlin",
  "Dolphin (Dorado, Mahi)",
  "Sailfish",
  "Spearfish",
  "Wahoo",
  "White Marlin",
  "Tuna",
]

export const checkinOptionList = [
  "Yes",
  "No"
]

export const hasPaidOptionList = [
  "Yes",
  "No"
]

export const ownerOptionList = [
  "Yes",
  "No"
]

export const captainOptionList = [
  "Yes",
  "No"
]

export const mateOptionList = [
  "Yes",
  "No"
]

export const paymentMethodOptionList = [
  "None",
  "Online (Credit Card)",
  "Mail-In",
  "Onsite (Cash)",
  "Onsite (Check)",
  "Onsite (Credit Card)",
  "Sponsored",
]

export const catchHeaderList = [
  'fish',
  'firstName',
  'lastName',
  'boatName',
  'weight',
  'length',
  'girth',
  'date',
  'time',
  'isTagged',
  'isPenalty',
  'weightPenalty',
  'pointsPenalty',
  'penaltyNotes',
  'includeInScoring',
  'points',
]

export const boatList = [
  'Poured Out',
  'Ambush',
  'A-Team',
  'Vamonos - Clement',
  'Big Trouble',
  'Blue Rush',
  'Boomin It Up',
  'Chingadera',
  'Backlash74',
  'Coco',
  'Coyote',
  'El Patron',
  'Instigator',
  'Fin Stalker',
  'Magnifico',
  'No Bad Daze',
  'Overnight Celebrity',
  'Playin Hooky',
  'Rebecca',
  'Reelity Check',
  'Sashimi',
  'Smooth Operator',
  'Stabilized',
  'Trophy Club',
  'Uno Mas',
  'Vaquero',
  'See-Mah',
]
